import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { IThreatAssessmentTeam } from '../../../../../shared/models/contact';
import { ContactsService } from '../../../../../shared/services/contact.service';
import { ActivatedRoute } from '@angular/router';
import { UserDataService } from '../../../../../shared/services/auth/userData.service';
import { SpinnerComponent } from '../../../../components/spinner/spinner.component';

@Component({
  selector: 'rms-schedule-official-signature',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SpinnerComponent
  ],
  templateUrl: './rms-schedule-official-signature.component.html',
  styleUrl: './rms-schedule-official-signature.component.css'
})
export class RmsScheduleOfficialSignatureComponent implements OnInit, OnChanges{

  @Input() rmsPlanReviewScheduleData: any;
  @Output() onSaveSection2 = new EventEmitter<any>();

  currentDate = new Date();
  rmsPlanReviewSignatureForm: FormGroup = new FormGroup([]);
  
  currentCaseId: string | null = null;
  currentBuildingId: string | null = null;
  currentContact: IThreatAssessmentTeam | null = null;
  messageModal: string | null = null;

  loading: boolean = false;

  constructor(
    private contactsService: ContactsService,
    private route: ActivatedRoute,
    private userDataService: UserDataService
  ) {}

  ngOnInit(): void {
    this.currentBuildingId = this.userDataService.getBuildingId();
    this.currentContact = this.userDataService.getCurrentUser();
    this.initializeForm();
    
    this.route.paramMap.subscribe((params) => {
      this.currentCaseId = params.get('caseId');
    });
  };

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['rmsPlanReviewScheduleData'] && this.rmsPlanReviewScheduleData) {
      this.initializeForm();
    }
  }

  private initializeForm(): void {
    this.rmsPlanReviewSignatureForm = new FormGroup({
      user_signature_name: new FormControl('', Validators.required),
    });
  }

  saveRmsPlanReviewSignature(): void {
    if (this.rmsPlanReviewSignatureForm.valid) {
      this.onSaveSection2.emit(this.rmsPlanReviewSignatureForm.value);
    }
  }
}
